import axios from 'axios'
import qs from 'qs'
axios.interceptors.response.use((res) => {
  return res.data
});

// 获取reason列表
export let getReasonList = (sceneid, param) => {
  return axios.post('//about.58.com/vote/data', qs.stringify({
    sceneid,
    param
  }))
};
// export let getReasonList = () => {
//   return axios.get('/static/data.json', {})
// };
// 通过reason获取组件状态
export let getCompomentState = (templateId, reasonId) => {
  return axios.post('//about.58.com/vote/attachment', qs.stringify({
    templateId,
    reasonId
  }))
};
// export let getCompomentState = () => {
//   return axios.get('/static/attachment.json', {})
// };
// 验证码
export let getCodeNum = (phone, source) => {
  return axios.post('//about.58.com/vote/getCaptcha', qs.stringify({
    phone,
    source
  }))
};
// export let getCodeNum = () => {
//   return axios.post('//about.58.com/vote/getCaptcha', {})
// };
// 上传图片
export let getPicLoad = (size, data, encode, path) => {
  // var instance = axios.create({
  //   baseURL: '//upload.58cdn.com.cn',
  //   headers: {
  //     'Content-Type': 'text/plain'
  //   }
  // });
  return axios.post('//upload.58cdn.com.cn/json?rand=0.126', JSON.stringify({
    "Pic-Size": size,
    "Pic-Encoding": encode,
    "Pic-Path": path,
    "Pic-Data": data
  }), {
    headers: {
      'Content-Type': 'text/plain'
    }
  })
}
// export let getPicLoad = () => {
//   return axios.post('//upload.58cdn.com.cn/json?rand=0.1298', {})
// }
// 提交
export let submitData = (param, reasonid, votephone, identitycard, votecontent, picupload, cheatdate, applyname, cheatmoney, captcha, responseid, email, sceneid) => {
  return axios.post('/vote/saveVoteV2', qs.stringify({
    param,
    reasonid,
    votephone,
    identitycard,
    votecontent,
    picupload: picupload,
    cheatdate,
    applyname,
    cheatmoney,
    captcha,
    responseid,
    email,
    sceneid
  }, {
    arrayFormat: 'brackets'
  }))
};
// export let submitData = () => {
//   return axios.post('/vote/saveVoteV2', {})
// };



// WEBPACK FOOTER //
// ./src/components/api/request.js